import { useMutation, useQuery } from 'apollo-3';

import { updateClassroomTimeActivities } from 'GraphQL/mutation/Classroom.mutation';
import { classroomTime } from 'GraphQL/query/Classroom.query';

const useClassroomTimeData = (props) => {
  const { refetch } = useQuery(classroomTime, { skip: true, ...props });
  const [updateClassroomTime] = useMutation(updateClassroomTimeActivities, { ...props });

  const handleGetClassroomTime = async ({ classroomTimeId }, onClassroomTimeOut) => {
    const res = await refetch({ classroomTimeId });
    const isValidRemainingTime = res?.data?.classroomTime?.isValidRemainingTime ?? true;
    if (!isValidRemainingTime) {
      onClassroomTimeOut();
    }
  };

  const handleUpdateClassroomTime = (
    {
      classroomTimeId,
      classroomId,
      courseId,
      subSectionReferId,
      timeSpending,
      learningMode,
      subsectionRevisionId,
      isCompleted,
      subject,
      isBonusContent,
      mode,
      courseRevisionId,
    },
    onClassroomTimeOut
  ) => {
    updateClassroomTime({
      variables: {
        classroomTimeId,
        classroomId,
        courseId,
        subSectionReferId,
        timeSpending,
        learningMode,
        subsectionRevisionId,
        isCompleted,
        subject,
        isBonusContent,
        mode,
        courseRevisionId,
      },
    }).then((res) => {
      if (typeof onClassroomTimeOut === 'function') {
        const statusCode = res?.data?.updateClassroomTimeActivities?.code;
        if (['403', 'FORBIDDEN'].includes(statusCode)) {
          onClassroomTimeOut();
        } else {
          handleGetClassroomTime({ classroomTimeId }, onClassroomTimeOut);
        }
      }
    });
  };

  return { handleGetClassroomTime, handleUpdateClassroomTime };
};

export default useClassroomTimeData;
